// ** Authetication **
// AUTH ACTION TYPES
export const LOGIN_INIT = "LOGIN_INIT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

//USER REGISTER ACTIONS TYPES
export const REGISTER_USER_INIT = "REGISTER_USER_INIT";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";

// USER FORGET_PASSWORD(send email)
export const USER_FORGOT_PASSWORD_INIT = "USER_FORGOT_PASSWORD_INIT";
export const USER_FORGOT_PASSWORD_SUCCESS = "USER_FORGOT_PASSWORD_SUCCESS";
export const USER_FORGOT_PASSWORD_FAIL = "USER_FORGOT_PASSWORD_FAIL";

// USER RESET PASSWORD (reset password)
export const USER_RESET_PASSWORD_INIT = "USER_RESET_PASSWORD_INIT";
export const USER_RESET_PASSWORD_SUCCESS = "USER_RESET_PASSWORD_SUCCESS";
export const USER_RESET_PASSWORD_FAIL = "USER_RESET_PASSWORD_FAIL";

// USER PROFILE DETAILS(After signup and in edit profile)
export const USER_PROFILE_DETAILS_INIT = "USER_PROFILE_DETAILS_INIT";
export const USER_PROFILE_DETAILS_SUCCESS = "USER_PROFILE_DETAILS_SUCCESS";
export const USER_PROFILE_DETAILS_FAIL = "USER_PROFILE_DETAILS_FAIL";

// USER IMAGES UPLOAD DETAILS(After signup and in edit profile)
export const USER_IMAGES_UPLOAD_INIT = "USER_IMAGES_UPLOAD_INIT";
export const USER_IMAGES_UPLOAD_SUCCESS = "USER_IMAGES_UPLOAD_SUCCESS";
export const USER_IMAGES_UPLOAD_FAIL = "USER_IMAGES_UPLOAD_FAIL";

// CHANGE PASSWORD
export const CHANGE_PASSWORD_INIT = "CHANGE_PASSWORD_INIT";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";

// LOGOUT
export const LOGOUT_INIT = "LOGOUT_INIT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

// ** OTHER USERS PROFILES **
// GET USERSPERSONAL DEATILS
export const USER_PERSONAL_DETAILS_INIT = "USER_PERSONAL_DETAILS_INIT"
export const USER_PERSONAL_DETAILS_SUCCESS = "USER_PERSONAL_DETAILS_SUCCESS"
export const USER_PERSONAL_DETAILS_FAIL = "USER_PERSONAL_DETAILS_FAIL"

//GET USERS PROFILES
export const GET_USERS_PROFILE_INIT = "GET_USERS_PROFILE_INIT";
export const GET_USERS_PROFILE_SUCCESS = "GET_USERS_PROFILE_SUCCESS";
export const GET_USERS_PROFILE_FAIL = "GET_USERS_PROFILE_FAIL";

// GET USER PROFILE BY ID
export const GET_USERS_BYID_INIT = "GET_USERS_BYID_INIT";
export const GET_USERS_BYID_SUCCESS = "GET_USERS_BYID_SUCCESS";
export const GET_USERS_BYID_FAIL = "GET_USERS_BYID_FAIL";

// GET CONTACTED USERS
export const GET_CONTACTED_USERS_INIT = "GET_CONTACTED_USERS_INIT";
export const GET_CONTACTED_USERS_SUCCESS = "GET_CONTACTED_USERS_SUCCESS";
export const GET_CONTACTED_USERS_FAIL = "GET_CONTACTED_USERS_FAIL";


// ** PAYMENT ** 
// GET PAYMENT HISTORY
export const PAYMENT_HISTORY_INIT = "PAYMENT_HISTORY_INIT";
export const PAYMENT_HISTORY_SUCCESS = "PAYMENT_HISTORY_SUCCESS";
export const PAYMENT_HISTORY_FAIL = "PAYMENT_HISTORY_FAIL";

// DELETE PAYMENT HISTORY
export const DELETE_PAYMENT_HISTORY_INIT = "DELETE_PAYMENT_HISTORY_INIT";
export const DELETE_PAYMENT_HISTORY_SUCCESS = "DELETE_PAYMENT_HISTORY_SUCCESS";
export const DELETE_PAYMENT_HISTORY_FAIL = "DELETE_PAYMENT_HISTORY_FAIL";

// PYMENT INTENT
export const PYMENT_INTENT_INIT = "PYMENT_INTENT_INIT";
export const PYMENT_INTENT_SUCCESS = "PYMENT_INTENT_SUCCESS";
export const PYMENT_INTENT_FAIL = "PYMENT_INTENT_FAIL";


// DROPDOWN
export const DROPDOWN_INIT = "DROPDOWN_INIT";
export const DROPDOWN_SUCCESS = "DROPDOWN_SUCCESS";
export const DROPDOWN_FAIL = "DROPDOWN_FAIL";

export const UPDATE_USER_PROFILE_INIT = "UPDATE_USER_PROFILE_INIT";
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS";
export const UPDATE_USER_PROFILE_FAIL = "UPDATE_USER_PROFILE_FAIL";

export const APPROVE_REJECT_PROFILE_INIT = "APPROVE_REJECT_PROFILE_INIT";
export const APPROVE_REJECT_PROFILE_SUCCESS = "APPROVE_REJECT_PROFILE_SUCCESS";
export const APPROVE_REJECT_PROFILE_FAIL = "APPROVE_REJECT_PROFILE_FAIL";
export const GET_PROFILE_ADMIN_INIT = 'GET_PROFILE_ADMIN_INIT';
export const GET_PROFILE_ADMIN_SUCCESS = 'GET_PROFILE_ADMIN_SUCCESS';
export const GET_PROFILE_ADMIN_FAIL = 'GET_PROFILE_ADMIN_FAIL';

export const DELETE_USER_ADMIN_INIT = 'DELETE_USER_ADMIN_INIT';
export const DELETE_USER_ADMIN_SUCCESS = 'DELETE_USER_ADMIN_SUCCESS';
export const DELETE_USER_ADMIN_FAIL = 'DELETE_USER_ADMIN_FAIL';

// statusCountActionTypes.js

// Get Status Count Action Types
export const GET_STATUS_COUNT_INIT = 'GET_STATUS_COUNT_INIT';
export const GET_STATUS_COUNT_SUCCESS = 'GET_STATUS_COUNT_SUCCESS';
export const GET_STATUS_COUNT_FAIL = 'GET_STATUS_COUNT_FAIL';
export const GET_STATUS_COUNT_RESET = 'GET_STATUS_COUNT_RESET';

// Optional: For real-time updates when profiles are approved/rejected/deleted
export const UPDATE_STATUS_COUNT = 'UPDATE_STATUS_COUNT';

export const DELETE_MY_PROFILE_INIT = 'DELETE_MY_PROFILE_INIT';
export const DELETE_MY_PROFILE_SUCCESS = 'DELETE_MY_PROFILE_SUCCESS';
export const DELETE_MY_PROFILE_FAIL = 'DELETE_MY_PROFILE_FAIL';

// SUB-ADMIN MANAGEMENT
export const GET_SUB_ADMINS_INIT = 'GET_SUB_ADMINS_INIT';
export const GET_SUB_ADMINS_SUCCESS = 'GET_SUB_ADMINS_SUCCESS';
export const GET_SUB_ADMINS_FAIL = 'GET_SUB_ADMINS_FAIL';

export const CREATE_SUB_ADMIN_INIT = 'CREATE_SUB_ADMIN_INIT';
export const CREATE_SUB_ADMIN_SUCCESS = 'CREATE_SUB_ADMIN_SUCCESS';
export const CREATE_SUB_ADMIN_FAIL = 'CREATE_SUB_ADMIN_FAIL';

export const UPDATE_SUB_ADMIN_INIT = 'UPDATE_SUB_ADMIN_INIT';
export const UPDATE_SUB_ADMIN_SUCCESS = 'UPDATE_SUB_ADMIN_SUCCESS';
export const UPDATE_SUB_ADMIN_FAIL = 'UPDATE_SUB_ADMIN_FAIL';

export const DELETE_SUB_ADMIN_INIT = 'DELETE_SUB_ADMIN_INIT';
export const DELETE_SUB_ADMIN_SUCCESS = 'DELETE_SUB_ADMIN_SUCCESS';
export const DELETE_SUB_ADMIN_FAIL = 'DELETE_SUB_ADMIN_FAIL';